import React, { useEffect, useState, useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import cn from 'classnames';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { Desktop, Mobile } from 'app/components/Responsive';
import { isDesktop } from 'app/utils/resolution';
import bgImgPath from './img/easterImg.d.jpg';
import TitleImgCompoent from './img/subtle.component.svg';
import css from './ball.scss';

const pagesToExclude = [
    '/offer/',
    '/privacy_policy/',
    '/personal_data_policy/',
    '/mailing_policy/',
    '/cookie_policy/',
    '/feedback/',
    '/feedback2/',
    '/faq/',
    '/about/',
    '/delivery/',
    '/halloweenalfaForm/',
    '/quality/',
    '/recycle/',
    '/ref-basket/',
    '/spb/',
    '/subscription/',
    '/survey/',
    '/service/',
    '/unpacking/',
];
const isSeenSaved = localStorage.getItem('cookies-rules-accepted') === 'true';

export const EasterBall = (props) => {
    const {
        position = 'deafult',
        page = 'deafult',
    } = props;
    const [isCooliesRules, setCooliesRules] = useState(isSeenSaved);

    const { data } = useQuery(
        gql`
                query CART_DATA(
                    $period: String!,
                ) {
                    cart(period: $period) {
                        sections {
                            id
                            cartType
                            items {
                                dish {
                                    id
                                }
                            }
                        }
                    }
                }
            `,
        {
            variables: {
                period: selectedPeriodVar(),
            },
            fetchPolicy: 'cache-first',
        },
    ) || {};

    const isBasketEmpty = useMemo(
        () => !data?.cart?.sections?.length,
        [data],
    );

    const isDesktopResolution = useMemo(
        () => isDesktop(),
        [window.innerWidth],
    );


    useEffect(() => {
        document.addEventListener('getNotificationRenderState', (e) => {
            const { detail: { renderState } } = e;
            console.log(renderState);
            setCooliesRules(renderState);
        });
    }, []);

    const ballRootClasses = cn({
        [css.isBottomPosition]: !isCooliesRules,
        [css.easterBallRoot]: true,
        [css[position]]: true,
        [css[page]]: true,
    });

    const ballLinkContClasses = cn({
        [css.easterBallLinkWrapper]: true,
        [css[page]]: true,
    });

    const isExclidingPages = useMemo(
        () => pagesToExclude.some((p) => p === window.location?.pathname),
        [],
    );

    if (isExclidingPages) {
        return null;
    }

    if (window.location.pathname === '/easterbox/' || window.location.pathname === '/easter/') {
        return null;
    }

    if ((page === 'promo-checkout-page') && isDesktopResolution && isBasketEmpty) {
        return null;
    }

    if (!isCooliesRules && (page === 'trial-page' || page === 'promo-checkout-page') && !isDesktopResolution) {
        return null;
    }

    return (
        <div className={ballRootClasses} onClickCapture={(e) => e.stopPropagation()}>
            <a href="/easterbox/" className={ballLinkContClasses}>
                <div className={css.easterBallBackground}>
                    <img src={bgImgPath} alt="" className={css.easterBallBackgroundImg} />
                </div>
                <div className={css.easterBallTitle}>
                    <div className={css.easterBallTitleBg}>
                        <div className={css.easterBallTitleText}>
                            <Mobile>
                                На Пасху
                            </Mobile>
                            <Desktop>
                                На Пасху
                            </Desktop>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};
